<template>
  <div>
    <template v-if="googleTagId">
      <noscript>
        <iframe :src="source"
        height="0" width="0" style="display:none;visibility:hidden">
        </iframe>
      </noscript>
    </template>
  </div>
</template>

<script>
/* eslint-disable */
	export default {
		name: "GTagManager",
		created() {
			(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
					new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
				j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
				'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
			})(window,document,'script','dataLayer',this.googleTagId);
		},
		props: {
			googleTagId: {
				type: String,
				required: true
			}
		},
		data() {
			return{
				source: `https://www.googletagmanager.com/ns.html?id=${this.googleTagId}`
			}
		}
	}
</script>

<style scoped>

</style>
